import { Injectable, OnInit } from '@angular/core';
import { AppConfig } from '../../app.config';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { HomeDetails } from '../models/home-details';
import { BaseService } from './base.service';
import { DashboardMenuOption } from '../models/dashboard';

@Injectable()
export class DashboardService extends BaseService{

    ngOnInit() {
        //this.getHomeDetails();
    }


    constructor(private http: Http, private config: AppConfig) { super(); }


    getDashboardMenuOptions(): Observable<DashboardMenuOption[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + "/api/dashboard/dashboarditems", { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <DashboardMenuOption[]>response.json();
            }), catchError(this.handleError))
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/dashboard.service.ts